import _StudentPerformance from './model';
import create from './create';

export const StudentPerformance = _StudentPerformance;

StudentPerformance.create = create;

export default StudentPerformance;



// WEBPACK FOOTER //
// ./data/GroupPerformance/StudentPerformance/index.js